export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/playcircle.d3ff56b5.svg","height":90,"width":90,"blurWidth":0,"blurHeight":0};